<div class="cv-resubmit-component" *ngIf="isResubmit">
	<div class="cv-resubmit-box" *ngIf="isImported">
		<div class="modal-header">
			<h5 class="modal-title">Order recall</h5>
			<button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="toggleReSubmitBox()">
				<span aria-hidden="true">&times;</span>
			</button>
		</div>
		<div class="modal-body">
			<p>
				This order was imported from <strong>'{{ dataOrder.externalProvider }}'</strong>.
				Do you want to recall it?
			</p>
		</div>
		<div class="modal-footer">
			<button type="button" class="btn btn-primary" (click)="reSubmitImported()">Confirm</button>
			<button type="button" class="btn btn-secondary" data-dismiss="modal" (click)="toggleReSubmitBox()">Close</button>
		</div>
	</div>
	<div class="cv-resubmit-box cv-resubmit-created-Order" *ngIf="!isImported">
		<div class="modal-header">
			<h5 class="modal-title">Order recall</h5>
			<button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="toggleReSubmitBox()">
				<span aria-hidden="true">&times;</span>
			</button>
		</div>
		<div class="modal-body">
			<cv-drag-and-drop-file
					[message]="filesDropMessage"
					(filesDropped)="onFilesDropped($event)"
			></cv-drag-and-drop-file>
		</div>
		<div class="modal-footer">
			<button type="button" class="btn btn-primary" [disabled]="!canResubmit" (click)="reSubmitCreated()">Confirm</button>
			<button type="button" class="btn btn-secondary" data-dismiss="modal" (click)="toggleReSubmitBox()">Close</button>
		</div>
	</div>
</div>
